var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPostPinCheckedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.8125 10H10.625C10.9702 10 11.25 9.72018 11.25 9.375V9.17245C11.25 8.1276 10.7278 7.15187 9.85844 6.57229L9.65331 6.43554C9.47944 6.31963 9.375 6.12448 9.375 5.91551V4.90674C9.375 4.76482 9.4233 4.62712 9.51196 4.5163L10.488 3.2962C10.5767 3.18538 10.625 3.04768 10.625 2.90576V1.875C10.625 1.52982 10.3452 1.25 10 1.25H5C4.65482 1.25 4.375 1.52982 4.375 1.875V2.90576C4.375 3.04768 4.4233 3.18538 4.51196 3.2962L5.48804 4.5163C5.5767 4.62712 5.625 4.76482 5.625 4.90674V5.91551C5.625 6.12448 5.52056 6.31963 5.34669 6.43554L5.14156 6.57229C4.27219 7.15187 3.75 8.1276 3.75 9.17245V9.375C3.75 9.72018 4.02982 10 4.375 10H7.1875V13.125C7.1875 13.2976 7.32741 13.4375 7.5 13.4375C7.67259 13.4375 7.8125 13.2976 7.8125 13.125V10Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPostPinCheckedIcon);
export default __webpack_public_path__ + "static/media/post-pin-checked-icon.da464ee41e0fec1ca0a7c478a090c200.svg";
export { ForwardRef as ReactComponent };